<template>
  <div>
    <el-button type="success" @click="showEducationalDialog = true">
      自動入力
    </el-button>

    <div class="education-option">
      <vue-final-modal
        v-model="showEducationalDialog"
        name="edu-auto-dialog"
        :classes="['edu-auto-dialog__container']"
        :content-class="[
          'edu-auto-dialog__content',
          'v--modal-box',
          'v--modal'
        ]"
        :click-to-close="true"
        :lock-scroll="true"
        attach="body"
      >
        <div class="v--modal-close-top">
          <el-button
            @click="closeDialog"
            icon="el-icon-close"
            type="text"
          ></el-button>
        </div>
        <div class="title">学歴自動入力</div>
        <p>生年月日と在籍年数を元に、入学・卒業年を自動計算します。</p>
        <p>※年は西暦で出力されます。</p>
        <p>&nbsp;</p>
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">生年月日</div>
            <div class="item-body flex align-items-center">
              <el-input
                class="input-xs"
                placeholder="2000"
                title="年"
                v-model="birthYear"
                min="1890"
                type="number"
              ></el-input
              ><span>年</span>
              <el-input
                class="input-xs input-2-digit"
                placeholder="00"
                title="月"
                v-model="birthMonth"
                min="1"
                max="12"
                type="number"
              ></el-input
              ><span>月</span>
              <el-input
                class="input-xs input-2-digit"
                placeholder="00"
                title="日"
                v-model="birthDay"
                min="1"
                max="31"
                type="number"
              ></el-input
              ><span>日</span>
            </div>
            <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
            <div class="item-name">最後の学歴</div>
            <div class="item-body">
              <el-select
                v-model="options.lastEducationalBackground"
                placeholder="Select"
              >
                <el-option
                  v-for="item in lastEducationalBackgroundOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="edu-auto-school">
            <div class="edit-form-item">
              <div class="item-name">
                中学校
                <el-checkbox
                  v-model="options.periods.juniorHighSchool.display"
                  class="edu-auto-checkbox"
                  >履歴書に記入する</el-checkbox
                >
              </div>
              <div class="item-body">
                <el-input
                  v-model="options.periods.juniorHighSchool.name"
                  v-show="options.periods.juniorHighSchool.display"
                  class="school-name"
                  :placeholder="
                    options.periods.juniorHighSchool.display
                      ? options.periods.juniorHighSchool.defaultName
                      : '記入されません'
                  "
                ></el-input>
                <el-input
                  v-model="options.periods.juniorHighSchool.period"
                  class="period input-2-digit"
                  controls-position="right"
                  type="number"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">
                <div
                  v-if="
                    options.lastEducationalBackground ===
                    'instituteOfTechnologyCollege'
                  "
                >
                  高等専門学校(高専)
                </div>
                <div v-else>
                  高等学校
                  <el-checkbox
                    v-model="options.periods.highSchool.display"
                    class="edu-auto-checkbox"
                    >履歴書に記入する</el-checkbox
                  >
                </div>
              </div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="
                    options.periods.highSchool.display
                      ? options.periods.highSchool.defaultName
                      : '記入されません'
                  "
                  v-model="options.periods.highSchool.name"
                  v-show="options.periods.highSchool.display"
                ></el-input>
                <el-input
                  v-model="options.periods.highSchool.period"
                  class="period input-2-digit"
                  type="number"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <span v-if="options.periods.highSchool.display">
                  <el-select
                    v-model="options.periods.highSchool.graduateLabel"
                    class="input-sm"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in graduateLabels"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </span>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="
                !(
                  options.lastEducationalBackground in
                  { highSchool: 1, instituteOfTechnologyCollege: 1 }
                )
              "
            >
              <div class="item-name">高校卒業後(予備校・浪人など)</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  disable
                  :placeholder="options.periods.afterHighSchool.defaultName"
                  v-model="options.periods.afterHighSchool.name"
                  v-show="false"
                ></el-input>
                <el-input
                  v-model="options.periods.afterHighSchool.period"
                  type="number"
                  class="period input-2-digit"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間</span>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="
                options.lastEducationalBackground in
                { university: 0, master: 0, docter: 0 }
              "
            >
              <div class="item-name">大学</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="options.periods.university.defaultName"
                  v-model="options.periods.university.name"
                ></el-input>
                <el-input
                  v-model="options.periods.university.period"
                  type="number"
                  class="period input-2-digit"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.university.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="options.lastEducationalBackground == 'juniorCollege'"
            >
              <div class="item-name">短期大学</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  v-model="options.periods.juniorCollege.name"
                  :placeholder="options.periods.juniorCollege.defaultName"
                  :disabled="
                    options.lastEducationalBackground != 'juniorCollege'
                  "
                ></el-input>
                <el-input
                  v-model="options.periods.juniorCollege.period"
                  type="number"
                  class="period input-2-digit"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.juniorCollege.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="options.lastEducationalBackground == 'specialSchool'"
            >
              <div class="item-name">専門学校</div>
              <div class="item-body">
                <el-input
                  v-model="options.periods.specialSchool.name"
                  class="school-name"
                  :placeholder="options.periods.specialSchool.defaultName"
                  :disabled="
                    options.lastEducationalBackground != 'specialSchool'
                  "
                ></el-input>
                <el-input
                  class="period input-2-digit"
                  type="number"
                  v-model="options.periods.specialSchool.period"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.specialSchool.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="
                options.lastEducationalBackground in { docter: 1, master: 1 }
              "
            >
              <div class="item-name">大学院（修士）</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="options.periods.master.defaultName"
                  v-model="options.periods.master.name"
                ></el-input>
                <el-input
                  class="period input-2-digit"
                  type="number"
                  v-model="options.periods.master.period"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.master.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="edit-form-item"
              v-if="options.lastEducationalBackground in { docter: 1 }"
            >
              <div class="item-name">大学院（博士）</div>
              <div class="item-body">
                <el-input
                  class="school-name"
                  :placeholder="options.periods.docter.defaultName"
                  v-model="options.periods.docter.name"
                ></el-input>
                <el-input
                  class="period input-2-digit"
                  type="number"
                  v-model="options.periods.docter.period"
                  controls-position="right"
                  :min="0"
                ></el-input
                ><span>年間在籍</span>
                <el-select
                  v-model="options.periods.docter.graduateLabel"
                  class="input-sm"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in graduateLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <el-button type="primary" @click="autoComplete"
            >この内容で追加</el-button
          >
          <el-button @click="closeDialog">閉じる</el-button>
          <div>※現在入力している学歴はすべて上書きされます</div>
        </div>
      </vue-final-modal>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/scss/format-edit/vfm-attach-body-fixed';
@include vfm-root-fixed-when-has('.edu-auto-dialog__container');

.edu-auto-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.edu-auto-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 1 auto;
  align-self: center;
  width: 600px;
  max-width: 100%;
  height: auto;
  max-height: 90vh;
  overflow-y: auto;
  margin-block: auto;
  padding: 20px 20px 50px;
  left: 0 !important;
}
</style>

<script setup lang="ts">
import { onMounted, reactive, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import graduateLabels from '@/utils/format-edit/graduateLabels.json'
import lastEducationalBackgroundOptions from '@/utils/format-edit/lastEducationalBackgroundOptions.json'
import {
  buildRirekishoList,
  createInitialEducationalOptions,
  type RirekishoListItem
} from '@/utils/format-edit/educationalBackgroundAuto'

const props = defineProps<{
  year?: number | string
  month?: number | string
  day?: number | string
}>()

const emit = defineEmits<{
  (e: 'create-educational-background', list: RirekishoListItem[]): void
}>()
const birthYear = ref<number | string | undefined>(1985)
const birthMonth = ref<number | string | undefined>(1)
const birthDay = ref<number | string | undefined>(1)
const errorMessage = ref('')
const showEducationalDialog = ref(false)
const options = reactive(createInitialEducationalOptions())
watch(
  () => props.year,
  (val) => (birthYear.value = val)
)
watch(
  () => props.month,
  (val) => (birthMonth.value = val)
)
watch(
  () => props.day,
  (val) => (birthDay.value = val)
)
watch(birthYear, (val) => emitter.emit('birth-year-changed', val))
watch(birthMonth, (val) => emitter.emit('birth-month-changed', val))
watch(birthDay, (val) => emitter.emit('birth-day-changed', val))
watch(
  () => options.lastEducationalBackground,
  (newVal) => {
    if (newVal === 'instituteOfTechnologyCollege') {
      options.periods.highSchool.period = 5
      options.periods.highSchool.defaultName =
        '国立〇〇工業高等専門学校　〇〇科'
    } else {
      options.periods.highSchool.period = 3
      options.periods.highSchool.defaultName = '県立〇〇高等学校 普通科'
    }
  }
)
function closeDialog() {
  showEducationalDialog.value = false
}
function autoComplete() {
  errorMessage.value = ''
  const year = birthYear.value
  const month = birthMonth.value
  const day = birthDay.value
  if (!year || !month || !day) {
    errorMessage.value = '生年月日を入力してください'
    return
  }
  emit(
    'create-educational-background',
    buildRirekishoList({
      birthYear: year,
      birthMonth: month,
      birthDay: day,
      options
    })
  )
  closeDialog()
}
onMounted(() => {
  birthYear.value = props.year
  birthMonth.value = props.month
  birthDay.value = props.day
})
</script>
